import "./modules/global";

document.addEventListener("DOMContentLoaded", () => {
	console.log("Certificates archive loaded");
});
